import request from '@/utils/request'
import { getToken } from "@/utils/auth";

// const searchApiPrefix = '/search-api'
const searchApiPrefix = window.config.searchApi;
const authorityApi = window.config.authorityLink;
const docApiPrefix = '/doc-api';
const wxApiPredix = '/ai-api';
const cwUrl = window.config.api_v1;

export function stockSearch(params) {
    return request({
        // headers:{
        //     "x-dzh-token": getToken()
        // },
        url: `${searchApiPrefix}/stock/query`,
        method: 'get',
        params
    })
}

// 权限验证
export function stockAuthority(url) {
    return request({
        url: authorityApi + url,
        method: 'get',
    })
}

// 查詢是否同意协议
export function getAgreementStatus() {
    return request({
        headers:{
            "x-dzh-token": getToken(),
        },
        url: `${docApiPrefix}/api/getAgreementStatus`,
        method: 'get',
    })
}

// 同意协议
export function signAgreement() {
    return request({
        headers:{
            "x-dzh-token": getToken(),
        },
        url: `${docApiPrefix}/api/signAgreement`,
        method: 'post',
    })
}

//  今日AI提示剩余次数
export function getAiRemainCount() {
    return request({
        headers:{
            "x-dzh-token": getToken(),
        },
        url: `${docApiPrefix}/api/getAiRemainCount`,
        method: 'post',
    })
}

// AI提问 gpt
// export function getAi(data) {
//     return request({
//         headers:{
//             "x-dzh-token": getToken(),
//         },
//         url: `${docApiPrefix}/api/ai`,
//         method: 'post',
//         data
//     })
// }

// AI提问 文心
export function getAi(data) {
    return request({
        headers:{
            "x-dzh-token": getToken(),
        },
        url: `${wxApiPredix}/baidu/completion`,
        method: 'post',
        data
    })
}

// 博士接口财务分析模块（现金流量表、资产负债表、资产负债表（AE）、利润表）
export function getCashFlow(params) {
    return request({
        url: `${cwUrl}/stock/info/cwzb`,
        method: 'get',
        params
    })
}